

import { useContext, useEffect, useState } from 'react';
import { Search, ChevronDown, ChevronUp } from 'react-feather'
import { useRemote } from '../../../Utils/Utils';
import { format } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { PAGES, ROUTE_PATHS } from '../../../InternalApiApp';
import { InfoBlockStatusToken } from '../../ActiveWorkflowsPage/WorkflowInfoBlock';
import { BannerContext } from '../../../InternalApiApp';
import Page, { PageContentBanner, PageContentBodyGrid } from '../../Shared/Page/Page';
import SimpleSearchFilter, { filterBy } from '../../../components/Input/SimpleSearchFilter';
import PageGridItem from '../../Shared/Page/PageGridItem';
import Table from '../../../components/Table/Table';
import Tooltip from '../../../components/popups/Tooltip';


const ExternalAccessList = ({ }) => {
    const remote = useRemote();
    const history = useHistory();
    const { setBannerBreadCrumbs } = useContext(BannerContext);

    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [sortingColumn, setSortingColumn] = useState({ column: "Company Name", ascending: true })

    useEffect(() => {
        remote.get("/crm/ext/access/lists").then(list => {
            setBannerBreadCrumbs({ tab: 'Companies' })
            setData(list)
            setLoading(false)
        }).catch(() => {
            setData([])
            setLoading(false)
        })
    }, [])

    function filter(dataToFilter) {
        if (searchTerm === null || searchTerm.trim().size === 0) {
            return dataToFilter
        }
        return dataToFilter.filter((datum) => filterBy(datum, ["name"], searchTerm))
    }

    function toggleSort(column) {
        if (column === null) {
            setSortingColumn({ column: "Company Name", ascending: true })
            return
        }
        const ascending = sortingColumn.column === column ? !sortingColumn.ascending : true
        setSortingColumn({ column: column, ascending: ascending })
    }

    function sortTable(dataToSort) {
        if (sortingColumn.column === null) {
            return dataToSort
        }

        let tableData = dataToSort
        const ascending = sortingColumn.ascending

        switch (sortingColumn.column) {
            case "Company Name":
                tableData.sort((a, b) => ascending ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name))
                break;
            case "Activation Date":
                tableData.sort((a, b) => {
                    if (!a.activationAt) return 1;
                    if (!b.activationAt) return -1;
                    return ascending ? a.activationAt.localeCompare(b.activationAt) : b.activationAt.localeCompare(a.activationAt);
                })
                break;
            case "Last Login":
                tableData.sort((a, b) => {
                    if (!a.lastUserActive) return 1;
                    if (!b.lastUserActive) return -1;
                    return ascending ? a.lastUserActive.lastLogin.localeCompare(b.lastUserActive.lastLogin) : b.lastUserActive.lastLogin.localeCompare(a.lastUserActive);
                })
                break;
            case "Status":
                tableData.sort((a, b) => ascending ? a.status.localeCompare(b.status) : b.status.localeCompare(a.status))
                break;
            default:
                break;
        }
        return tableData
    }
    const filteredData = filter(data)
    const sortedData = sortTable(filteredData)

    const colWidths = ['39%', '15%', '23%', '23%']
    const headers = [
        {
            text: (
                <div className='sorting-header' onClick={() => toggleSort("Company Name")} >
                    Company Name
                    {sortingColumn && sortingColumn.column === "Company Name" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "Name" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
        {
            text: (
                <div className='sorting-header' onClick={() => toggleSort("Status")} >
                    Status
                    {sortingColumn && sortingColumn.column === "Status" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "Status" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
        {
            text: (
                <div className='sorting-header' onClick={() => toggleSort("Activation Date")} >
                    Activation Date
                    {sortingColumn && sortingColumn.column === "Activation Date" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "Activation Date" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
        {
            text: (
                <div className='sorting-header' onClick={() => toggleSort("Last Login")} >
                    Last Login
                    {sortingColumn && sortingColumn.column === "Last Login" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "Last Login" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        }
    ];

    const dataMap = (dataToMap) => {
        return dataToMap.map((template) => {
            const { externalAccessId, name, status, activationAt, lastUserActive } = template
            return (
                <tr className='tr-borders cursor-pointer' key={name} onClick={() => history.push(ROUTE_PATHS[PAGES.ADMIN] + "/external-access/companies/" + externalAccessId)}>
                    <td style={{ paddingLeft: '0.5rem' }}>{name}</td>
                    <td><Tooltip disabled={status === "ACTIVE"} label="To activate this company, please add at least one domain."><InfoBlockStatusToken status={status} /></Tooltip></td>
                    <td>{activationAt ? format(new Date(activationAt), 'dd/MM/yyyy') : '-'}</td>
                    <td>{lastUserActive && lastUserActive.lastLogin ? format(new Date(lastUserActive.lastLogin), 'HH:mmaaa dd/MM/yyyy') : '-'}</td>
                </tr>
            )
        })
    }


    return (
        <Page fixedBanner>
            <PageContentBanner divider>
                <SimpleSearchFilter
                    size='small'
                    width='xxl'
                    placeholder={`Search Company (${data.length})`}
                    isClearable
                    icon={<Search />}
                    setSearchTerm={setSearchTerm}
                    searchTerm={searchTerm}
                />
            </PageContentBanner>
            <PageContentBodyGrid id="client-details-page" rowGap="xl" gridTemplateRows="1fr" splitScroll paddingBottom='4.5rem'>
                <PageGridItem container col="1 / span 12">
                    <Table
                        minWidth={800}
                        colWidths={colWidths}
                        headers={headers}
                        dataMap={dataMap(sortedData)}
                        dataLoading={loading}
                    />
                </PageGridItem>
            </PageContentBodyGrid >
        </Page >
    )
}

export default ExternalAccessList;